/* eslint-disable @typescript-eslint/no-unused-vars */
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FacetUrlListingPluginService } from './plugin/listing.plugin.service';
import { FacetUrlMetaAlternatePluginService } from './plugin/meta-alternate.plugin.service';
import { FacetUrlMetaPluginService } from './plugin/meta.plugin.service';
import { FacetOverridePipe } from './util/facet-override.pipe';
import { FacetUrlPipe } from './util/facet-url.pipe';

@NgModule({
    imports: [FacetOverridePipe, FacetUrlPipe],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory:
                (
                    facetUrlListingPluginService: FacetUrlListingPluginService,
                    facetUrlMetaPluginService: FacetUrlMetaPluginService,
                    facetUrlMetaAlternatePluginService: FacetUrlMetaAlternatePluginService
                ) =>
                () => {
                    facetUrlListingPluginService.appInitialize();
                    facetUrlMetaPluginService.appInitialize();
                    facetUrlMetaAlternatePluginService.appInitialize();
                },
            deps: [FacetUrlListingPluginService, FacetUrlMetaPluginService, FacetUrlMetaAlternatePluginService],
            multi: true
        }
    ],
    exports: [FacetOverridePipe, FacetUrlPipe]
})
export class FacetUrlModule {}
